'use client';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Link from 'next/link';

export default function CookiePolicyPage() {
  return (
    <>
      <Header lang="it" />
      <main style={{ background: '#071520', minHeight: '100vh' }}>
        {/* Hero */}
        <section
          style={{
            background: 'linear-gradient(180deg, #0B1F2E 0%, #071520 100%)',
            borderBottom: '1px solid rgba(240,247,255,0.06)',
            padding: '64px 0 48px',
          }}
        >
          <div className="container-main" style={{ maxWidth: '800px' }}>
            <p style={{ fontSize: '12px', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#00D4FF', marginBottom: '12px' }}>
              Documenti legali
            </p>
            <h1
              style={{
                fontFamily: 'Fraunces, Georgia, serif',
                fontSize: 'clamp(28px, 5vw, 44px)',
                fontWeight: 700,
                color: '#F0F7FF',
                lineHeight: 1.2,
                marginBottom: '16px',
              }}
            >
              Cookie Policy
            </h1>
            <p style={{ fontSize: '15px', color: 'rgba(240,247,255,0.5)', lineHeight: 1.7 }}>
              Ultimo aggiornamento: aprile 2025
            </p>
          </div>
        </section>

        {/* Content */}
        <section style={{ padding: '56px 0 80px' }}>
          <div className="container-main" style={{ maxWidth: '800px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>

              <LegalSection title="Cosa sono i cookie">
                <p>
                  I cookie sono piccoli file di testo che i siti web salvano sul tuo dispositivo quando li visiti. Servono a far funzionare il sito correttamente, a ricordare le tue preferenze e, in alcuni casi, a raccogliere informazioni statistiche sull'utilizzo del sito.
                </p>
                <p>
                  Non tutti i cookie sono uguali: alcuni sono indispensabili per il funzionamento del sito, altri richiedono il tuo consenso prima di essere attivati.
                </p>
              </LegalSection>

              <LegalSection title="Tipologie di cookie che utilizziamo">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <CookieCard
                    type="Tecnici / Necessari"
                    badge="Sempre attivi"
                    badgeColor="#00D4FF"
                    description="Questi cookie sono indispensabili per il funzionamento del sito. Permettono di navigare tra le pagine, completare una prenotazione e utilizzare le funzionalità di base. Non raccolgono informazioni personali e non richiedono il tuo consenso."
                    examples={['Sessione di navigazione', 'Preferenze di lingua', 'Stato del carrello / prenotazione']}
                  />
                  <CookieCard
                    type="Funzionali"
                    badge="Consenso facoltativo"
                    badgeColor="rgba(240,247,255,0.4)"
                    description="Questi cookie migliorano la tua esperienza ricordando le tue preferenze (ad esempio la lingua o la posizione). Non sono strettamente necessari, ma rendono il sito più comodo da usare."
                    examples={['Preferenze di visualizzazione', 'Dati compilati in precedenza']}
                  />
                  <CookieCard
                    type="Analitici"
                    badge="Consenso richiesto"
                    badgeColor="#FFB347"
                    description="Questi cookie raccolgono informazioni aggregate su come i visitatori utilizzano il sito: quali pagine vengono visitate, quanto tempo si trascorre su ciascuna, da dove provengono gli utenti. I dati raccolti sono utilizzati in forma aggregata e, ove possibile, anonimizzata, al solo scopo di migliorare il funzionamento del sito."
                    examples={['Pagine visitate', 'Durata della sessione', 'Provenienza del traffico']}
                  />
                </div>
              </LegalSection>

              <LegalSection title="Cookie di terze parti">
                <p>
                  Alcuni servizi integrati nel sito (come sistemi di pagamento o strumenti di analisi) possono installare cookie propri. In questi casi, il trattamento dei dati è regolato dalle rispettive privacy policy dei fornitori.
                </p>
                <p>
                  Non utilizziamo cookie di profilazione per finalità pubblicitarie.
                </p>
              </LegalSection>

              <LegalSection title="Servizi di terze parti utilizzati">
                <p>
                  Per il corretto funzionamento del sito e del processo di prenotazione, utilizziamo servizi forniti da terze parti che possono installare cookie tecnici o analitici.
                </p>
                <p>Questi servizi includono, ad esempio:</p>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingLeft: '0', listStyle: 'none' }}>
                  {[
                    'sistemi di pagamento online',
                    'strumenti di gestione delle prenotazioni',
                    'servizi di hosting e infrastruttura web',
                  ].map((item, i) => (
                    <li key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', color: 'rgba(240,247,255,0.65)', fontSize: '14px', lineHeight: 1.6 }}>
                      <span style={{ color: '#00D4FF', fontWeight: 700, flexShrink: 0 }}>→</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <p>
                  Il trattamento dei dati da parte di tali servizi è regolato dalle rispettive informative privacy.
                </p>
              </LegalSection>

              <LegalSection title="Il tuo consenso">
                <p>
                  Al primo accesso al sito, ti viene mostrato un banner che ti permette di scegliere quali cookie accettare. I cookie tecnici sono sempre attivi perché necessari al funzionamento del sito.
                </p>
                <p>
                  Per i cookie non essenziali (funzionali e analitici), la tua scelta viene salvata e rispettata. Puoi modificare le tue preferenze in qualsiasi momento. Puoi modificare o revocare il tuo consenso in qualsiasi momento tramite il banner cookie disponibile sul sito.
                </p>
              </LegalSection>

              <LegalSection title="Come modificare le preferenze">
                <p>
                  Puoi gestire o revocare il consenso ai cookie in qualsiasi momento attraverso le impostazioni del tuo browser. Ogni browser ha procedure diverse:
                </p>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingLeft: '0', listStyle: 'none' }}>
                  {[
                    'Chrome: Impostazioni → Privacy e sicurezza → Cookie',
                    'Firefox: Preferenze → Privacy e sicurezza → Cookie',
                    'Safari: Preferenze → Privacy → Gestisci dati siti web',
                    'Edge: Impostazioni → Cookie e autorizzazioni sito',
                  ].map((item, i) => (
                    <li key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', color: 'rgba(240,247,255,0.65)', fontSize: '14px', lineHeight: 1.6 }}>
                      <span style={{ color: '#00D4FF', fontWeight: 700, flexShrink: 0 }}>→</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <p>
                  Tieni presente che disabilitare alcuni cookie potrebbe influire sul corretto funzionamento del sito o del processo di prenotazione.
                </p>
              </LegalSection>

              <LegalSection title="Maggiori informazioni">
                <p>
                  Per ulteriori informazioni sul trattamento dei tuoi dati personali, consulta la nostra{' '}
                  <Link href="/it/privacy-policy" style={{ color: '#00D4FF' }}>Privacy Policy</Link>.
                </p>
                <p>
                  Per domande o richieste, scrivi a{' '}
                  <a href="mailto:info@e-foilexperience.com" style={{ color: '#00D4FF' }}>info@e-foilexperience.com</a>.
                </p>
              </LegalSection>

            </div>
          </div>
        </section>
      </main>
      <Footer lang="it" />
    </>
  );
}

function LegalSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2
        style={{
          fontFamily: 'Fraunces, Georgia, serif',
          fontSize: '22px',
          fontWeight: 700,
          color: '#F0F7FF',
          marginBottom: '20px',
          paddingBottom: '12px',
          borderBottom: '1px solid rgba(240,247,255,0.08)',
        }}
      >
        {title}
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        {children}
      </div>
    </div>
  );
}

interface CookieCardProps {
  type: string;
  badge: string;
  badgeColor: string;
  description: string;
  examples: string[];
}

function CookieCard({ type, badge, badgeColor, description, examples }: CookieCardProps) {
  return (
    <div
      style={{
        background: 'rgba(240,247,255,0.03)',
        border: '1px solid rgba(240,247,255,0.08)',
        borderRadius: '12px',
        padding: '20px 24px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', flexWrap: 'wrap' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#F0F7FF', margin: 0 }}>{type}</h3>
        <span
          style={{
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: badgeColor,
            background: `${badgeColor}18`,
            border: `1px solid ${badgeColor}30`,
            borderRadius: '20px',
            padding: '3px 10px',
          }}
        >
          {badge}
        </span>
      </div>
      <p style={{ fontSize: '14px', color: 'rgba(240,247,255,0.65)', lineHeight: 1.7, marginBottom: '12px' }}>{description}</p>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {examples.map((ex, i) => (
          <span
            key={i}
            style={{
              fontSize: '12px',
              color: 'rgba(240,247,255,0.45)',
              background: 'rgba(240,247,255,0.05)',
              border: '1px solid rgba(240,247,255,0.08)',
              borderRadius: '6px',
              padding: '4px 10px',
            }}
          >
            {ex}
          </span>
        ))}
      </div>
    </div>
  );
}
